import { motion } from "framer-motion";
import { Mail, Phone, MapPin } from "lucide-react";
import { Link, useNavigate } from "react-router-dom";
import { IMAGES } from "@/data/images";
import { SERVICES } from "@/data/servicesData";
import { AREAS } from "@/data/areasData";

export const Footer = () => {
  const navigate = useNavigate();
  const goQuote = () => { navigate("/"); setTimeout(() => document.querySelector("#quote")?.scrollIntoView({ behavior: "smooth" }), 350); };

  return (
    <footer className="bg-[#0A1A4A] text-white pt-20 pb-10" data-testid="footer">
      <div className="max-w-[1400px] mx-auto px-5 sm:px-8">
        <motion.div
          initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }}
          className="grid lg:grid-cols-12 gap-12 pb-16 border-b border-white/15"
        >
          <div className="lg:col-span-4">
            <Link to="/" className="flex items-center gap-3 mb-6">
              <img src={IMAGES.logo} alt="FIT N FIX DIY Services Swansea" className="h-14 w-14 rounded-full border-2 border-white" />
              <div className="font-display font-black text-2xl tracking-tight">FIT N FIX</div>
            </Link>
            <div className="font-display font-black text-4xl sm:text-5xl leading-[0.95] tracking-tight">
              FIX IT.<br /><span className="text-[#2563EB]">FIT N FIX DIY.</span><br /><span className="text-[#EAB308]">SORTED.</span>
            </div>
          </div>

          <div className="lg:col-span-3">
            <div className="font-mono-accent text-[11px] tracking-widest uppercase text-white/50 mb-5">Services</div>
            <ul className="space-y-2.5">
              {SERVICES.map((s) => (
                <li key={s.slug}>
                  <Link to={`/services/${s.slug}`} className="text-white/80 hover:text-[#2563EB] transition-colors text-sm">{s.short}</Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-2">
            <div className="font-mono-accent text-[11px] tracking-widest uppercase text-white/50 mb-5">Areas</div>
            <ul className="space-y-2.5">
              {AREAS.map((a) => (
                <li key={a.slug}>
                  <Link to={`/areas/${a.slug}`} className="text-white/80 hover:text-[#2563EB] transition-colors text-sm">{a.area}</Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-3">
            <div className="font-mono-accent text-[11px] tracking-widest uppercase text-white/50 mb-5">Get In Touch</div>
            <a href="mailto:fitnfixdiy@outlook.com" className="flex items-center gap-3 text-white/85 hover:text-[#2563EB] transition-colors mb-4" data-testid="footer-email">
              <Mail size={18} className="text-[#2563EB]" /> fitnfixdiy@outlook.com
            </a>
            <a href="tel:+447966350733" className="flex items-center gap-3 text-white/85 hover:text-[#2563EB] transition-colors mb-4" data-testid="footer-phone">
              <Phone size={18} className="text-[#2563EB]" /> 07966 350733
            </a>
            <div className="flex items-center gap-3 text-white/85 mb-6">
              <MapPin size={18} className="text-[#2563EB]" /> Swansea &amp; Gower, Wales
            </div>
            <Link to="/tips" className="block text-white/80 hover:text-[#2563EB] transition-colors text-sm mb-6" data-testid="footer-tips">Tips &amp; Advice →</Link>
            <button onClick={goQuote} data-testid="footer-quote" className="bg-[#2563EB] text-white font-display font-extrabold text-sm uppercase tracking-wide px-5 py-3 border-2 border-white hover:bg-white hover:text-[#0A1A4A] transition-colors">
              Get A Quote
            </button>
          </div>
        </motion.div>

        <div className="pt-8 flex flex-col sm:flex-row justify-between gap-3 font-mono-accent text-[11px] tracking-widest uppercase text-white/45">
          <div>© {new Date().getFullYear()} FIT N FIX DIY Services</div>
          <div>£60 Minimum Charge · Fully Insured</div>
        </div>
      </div>
    </footer>
  );
};
